export default __webpack_public_path__ + "static/media/calendar.9d38b353.svg";